angular.module('leanlaw').directive('llSplit', ['$compile', '$http', function ($compile, $http) {
  return {
    restrict: 'EA',
    scope: {
      ngModel: '='
    },
    link: function (scope, element, attrs) {
      scope.$watch('ngModel', function (string) {
        var html = string ? "<span>" + string.replace(/\n/, "<br/>") + "</span>" : '';
        element.html($compile(html)(scope));
      });
    }
  };
}]);